import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { CaixaService } from 'app/service/caixa/caixa.service';
import { AreaService } from 'app/service/cliente/area.service';
import { ClienteService } from 'app/service/cliente/cliente.service';
import {MatTableDataSource, MatPaginator, MatSort} from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TipoCaixaService } from 'app/service/caixa/tipo-caixa.service';
import { TipoCaixaModel } from 'app/model/caixa/tipocaixa.model';
import { MatTable } from '@angular/material/table';

@Component({
  selector: 'app-gerenciar-protocolo',
  templateUrl: './gerenciar-protocolo.component.html',
  styleUrls: ['./gerenciar-protocolo.component.scss']
})
export class GerenciarProtocoloComponent implements OnInit, AfterViewInit {
  public clientes: ClienteModel[];
  public areas: any[] = [];
  public numeracaoArray: any[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<any[]>([]);
  selection = new SelectionModel<any>(true, []);
  displayedColumns: string[] = ['check', 'numeracao', 'cod_protocolo', 'input'];
  areaSelected;
  showTable = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  tipoCaixas: TipoCaixaModel[];
  empresaId;
  tipoCaixaId;
  replicarInfo = false;
  replicar = false;
  constructor(
    private clienteService: ClienteService,
    private areaService: AreaService,
    private caixaService: CaixaService,
    private solicitacaoService: SolicitacaoService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private tipoCaixaService: TipoCaixaService
  ) { }

  ngOnInit() {
    this.listarClientesUsuario();
    this.getTipoCaixa(0,10);
  }

  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
    }, err => {
      console.error(err);
    });
  }

  listarAreasCliente(e: any) {
    this.empresaId = e.value.id;
    this.areaService.getAreasUsuarioCliente(e.value.id).subscribe(data => {
      this.areas = data;
    }, err => {
      console.error(err);
    });
  }

  selectArea(e: any) {
    this.areaSelected = e.value.id;
  }

  selectTipoCaixa(e: any) {
    this.tipoCaixaId = e.value.id;
  }

  getIdFromArea() {
    this.caixaService.listNumeracaoCaixaArea(this.areaSelected).subscribe(data => {
      this.numeracaoArray = data;
      this.showTable = true;
      const groupedData = this.groupData(this.numeracaoArray);
      this.dataSource = new MatTableDataSource(groupedData);
    }, err => {
      console.error(err);
    });
  }

  getOrganizacao() {
    this.caixaService.listNumeracaoCaixaAreaOrganizacao(this.areaSelected).subscribe(data => {
      console.log(data);
      this.numeracaoArray = data;
      this.showTable = true;
      //const groupedData = this.groupData(this.numeracaoArray);
      this.dataSource = new MatTableDataSource(data);
    }, err => {
      console.error(err);
    });
  }

  groupData(data: any[]): any[] {
    const groupedData = [];
    for (let i = 0; i < data.length; i += 2) {
      if (data[i + 1]) {
        groupedData.push({id1: data[i].id, id2: data[i + 1].id, idGroup: `${data[i].valor}-${data[i + 1].valor}`, cod: data[i].codSolicitacao });
      } else {
        groupedData.push({ id1: data[i].id, idGroup: `${data[i].valor}`, cod: data[i].codSolicitacao });
      }
    }
    return groupedData;
  }

  toggleAllRows(event) {
    if (event.checked) {
      // Selecionar apenas os itens visíveis na página atual
      const visibleRows = this.dataSource._pageData(this.dataSource._orderData(this.dataSource.data));
      this.selection.select(...visibleRows);
    } else {
      this.selection.clear();
    }
  }

  toggleRow(row) {
    this.selection.toggle(row);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.pageIndex = 0;
    }
  }

  updateInputValue(id1: number, event: any): void {
      let valor = event.target.value;
      let index = this.dataSource.data.findIndex((data: any) => data.id1 === id1);
      this.dataSource.data[index]['info'] = valor;
    
    //this.dataSource[index].info = value;
  }

  criarSolicitacao() {
    if (this.selection.selected.length > 0) {
      let body = {
        areaId: this.areaSelected,
        clienteId: this.empresaId,
        tipoCaixaId: this.tipoCaixaId,
        numeros: this.selection.selected
      }
      this.solicitacaoService.criarSolicitacaoImplantacaoProtocolo(body).subscribe(data => {
        this.openSnackBarSuccess('Solicitação criada com sucesso.');
        this.router.navigate(['/solicitacoes']);
        this
      }, err => {
        console.error(err);
      });
    } else {
      this.openSnackBarError('Nenhum item selecionado.');
    }
    
  }

  getTipoCaixa(page: number, size: number) {
    this.tipoCaixaService.getTipoCaixas(page, size).subscribe(
      (data) => {
        this.tipoCaixas = data.content;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

  functionReplicarInfo(e: any) {
    this.replicar = e.target.checked;
  }
  
}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/gerenciar-protocolo/gerenciar-protocolo/gerenciar-protocolo.component.ts